// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"31":"lucky-draws","309":"liff-auth","649":"page-not-found","801":"rewards","962":"home"}[chunkId] || chunkId) + "." + {"31":"2ce3647a","309":"19633486","649":"cd6d68d6","801":"14b86500","894":"5a6e5783","962":"928fcbdb"}[chunkId] + ".js";
};